export const COIN_GECKO_URL = "https://api.coingecko.com/api/v3/coins/";
export const APP_NAME = "CryptoTracker.";
export const APP_DESCRIPTION =
  "CryptoTracker is the tracker you always needed. Compare different crypto currencies, look at their graphs - prices, total volumes, market cap, etc. Search from the top 100 Crypto currencies in real time.";
export const APP_KEYWORDS =
  "CryptoTracker., crypto, tracker, crypto dashboard, dashboard";
export const APP_AUTHOR = "Avi Vashishta";
export const APP_URL = "https://crypto-dashboard-avi.netlify.app/";